import { ProblemType } from '@customer-frontend/graphql-types';

const skinProblemTypes: ProblemType[] = ['ACNE', 'ANTI_AGEING', 'SKIN_GENERAL'];

export const isSkinProblemType = (problemType?: ProblemType): boolean =>
  !!problemType && skinProblemTypes.includes(problemType);
